// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ShippingInfoResourceViewModel from '../../../../viewModel/resource/ShippingInfoResourceViewModel';
import VatSummaryResourceViewModel from '../../../../viewModel/resource/VatSummaryResourceViewModel';
import BasketSummaryResourceViewModel from '../../../../viewModel/resource/BasketSummaryResourceViewModel';
import BasketSummaryResourceDTO from '../../dto/resource/BasketSummaryResourceDTO';

export default abstract class BasketSummaryResourceModel extends BaseModel<BasketSummaryResourceDTO> {
  /**
  */
  get priceType() { return this.dto.priceType; }
  set priceType(value) { this.dto.priceType = value; }
  /**
  * @type {double}
  */
  get netAmount() { return this.dto.netAmount; }
  set netAmount(value) { this.dto.netAmount = value; }
  /**
  * @type {double}
  */
  get vatAmount() { return this.dto.vatAmount; }
  set vatAmount(value) { this.dto.vatAmount = value; }
  /**
  * @type {double}
  */
  get grossAmount() { return this.dto.grossAmount; }
  /**
  */
  get shippingInfo() { return this.getObjectModel(() => this.dto.shippingInfo, ShippingInfoResourceViewModel)!; }
  set shippingInfo(value) { this.setObjectModel(() => this.dto.shippingInfo, value); }
  /**
  * @type {double}
  */
  get grandTotalAmount() { return this.dto.grandTotalAmount; }
  /**
  * @type {double}
  */
  get totalWeight() { return this.dto.totalWeight; }
  set totalWeight(value) { this.dto.totalWeight = value; }
  /**
  * @type {int32}
  */
  get totalQuantity() { return this.dto.totalQuantity; }
  set totalQuantity(value) { this.dto.totalQuantity = value; }
  /**
  */
  get vatSummaryItems() { return this.getArrayModels(() => this.dto.vatSummaryItems, VatSummaryResourceViewModel)!; }
  set vatSummaryItems(value) { this.setArrayModels(() => this.dto.vatSummaryItems, value); }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    this.dto.priceType = qs.pricetype;
    value = Number.parseFloat(qs.netamount);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.netAmount = value;
    value = Number.parseFloat(qs.vatamount);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.vatAmount = value;
    value = Number.parseFloat(qs.totalweight);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.totalWeight = value;
    value = Number.parseFloat(qs.totalquantity);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.totalQuantity = value;
  }
}
